export default __webpack_public_path__ + "static/media/prenatalLandingPageHowItWorksStep2.6361ec64.png";